export var QuantityInclude = {
    organization: true,
    product: true,
    customers: true,
    tags: true,
};
//# sourceMappingURL=Quantity.js.map